<template>
    <div class="page-sign-up" style="margin-top: 100px; margin-left: 40px; margin-right: 40px; "> 
        <div class="columns">
            <div class="column is-4 is-offset-4">
                <h4 class="title">Logging out...</h4>                    
            </div>
        </div>
    </div>
</template>

<script>
import { toast } from 'bulma-toast'

export default {
        name: 'Logout',
        data() {
            return {
                isActive: false,
                username: '',
                password: '',
                errors: [],
            }
        },    
        mounted() {
            document.title = 'Logging Out... | Wishboard'

            this.$router.push("/login"); 
            // google.accounts.id.revoke(this.usernam, done => {
            //     console.log('consent revoked');
            // });
            // gapi.load('auth2', () => {
            //     gapi.auth2.init()
            //     var auth2=gapi.auth2.getAuthInstance()
            //     auth2.signOut()
            //       .then(() => { console.log('User signed out.') })
            //       .then(() => { 
            //           setTimeout(() => {  
            //             this.$router.push("/login");  
            //           }, 300);
                      
            //                 toast({
            //                     message: 'Logged out ',
            //                     type: 'is-success',
            //                     dismissible: true,
            //                     pauseOnHover: false, 
            //                     duration: 3000,
            //                     position: 'bottom-center'
            //                 })    
            //       });
            //   });
        },
        methods: {
        }
}


</script>